import {Controller} from "@hotwired/stimulus";
import {TaggedLogger} from "@nextlot/core/utilities";
import {debounce} from 'es-toolkit/function';
import intlTelInput, { Iso2 } from 'intl-tel-input';

import NextLotJSDATA from "@nextlot/core/NextLotJSDATA";

const _logger = TaggedLogger.get('FormWithPhoneNumberInputsController');


// TODO FIXME move this as a per <input> controller directly, instead of per <form> with inputs
export default class FormWithPhoneNumberInputsController extends Controller {
  static targets = ["phoneNumberInput"]


  initialize() {
    this.validatePhoneNumberInput = debounce(this.validatePhoneNumberInput, 500).bind(this);
  }


  validatePhoneNumberInput(event: InputEvent) {
    const inputElement = event.target as HTMLInputElement;
    const inputIntInstance = intlTelInput.getInstance(inputElement);
    const notRequiredAndEmpty = !inputElement.required && inputElement.value.length === 0;
    const isInputPhoneNumberValid = notRequiredAndEmpty || inputIntInstance.isValidNumber();

    if (notRequiredAndEmpty) {
      // allow user to delete phone number if the field is not required eg: bidder alt phone number
      inputElement.classList.remove("is-valid");
      inputElement.classList.remove("is-invalid");
    }
    else {
      if (isInputPhoneNumberValid) {
        inputElement.setCustomValidity("");
        inputElement.classList.remove("is-invalid");
        inputElement.classList.add("is-valid");

      }
      else {
        inputElement.setCustomValidity("Invalid phone number");
        inputElement.classList.remove("is-valid");
        inputElement.classList.add("is-invalid");
      }
    }

    inputElement.reportValidity();
  }


  phoneNumberInputTargetConnected(inputElement: HTMLInputElement) {
    intlTelInput(inputElement, {
      loadUtils: () => import("intl-tel-input/utils"),

      hiddenInputs: () => {
        return {
          phone: inputElement.name,
        };
      },

      containerClass: "w-100",
      countrySearch: true,
      countrySelectorMode: 'AUTO',
      matchDropdownWidth: true,
      separateDialCode: true,
      showFlags: true,

      countryOrder: ['us', 'ca', 'au', 'mc', 'nl', 'mx'],
      initialCountry: NextLotJSDATA.current_site?.business_address_country_code as Iso2 || 'us',

      formatAsYouType: true,
      numberDisplayFormat: 'INTERNATIONAL',
      strictMode: true,
      strictRejectAnimation: true,

      allowPhonewords: false,
      allowNumberExtensions: false,

      placeholderNumberPolicy: 'POLITE',
    });

    inputElement.addEventListener("input", this.validatePhoneNumberInput);
  }


  phoneNumberInputTargetDisconnected(inputElement: HTMLInputElement) {
    inputElement.removeEventListener("input", this.validatePhoneNumberInput)
    intlTelInput.getInstance(inputElement)?.destroy()
  }

}
